import React from "react";
import { getPQRValue } from "./pqrDataUtils";
import { pqrStyles } from "./pqrStyles";

const PQRJointTable = ({ pdf, type = "Groove", previewUrl1, previewUrl2 }) => {
  const pdfData = pdf[0];
  const isOverlay = type === "Overlay";

  if (isOverlay) {
    return (
      <>
        <div style={pqrStyles.group}>
          <div className="PQRbasemetal">JOINTS(QW - 402)</div>
        </div>
        <div style={pqrStyles.container}>
          <table id="table" className="PQRTable2">
            <tbody>
              <tr>
                <th style={{ width: "9.3%", paddingLeft: "3px" }} className="PQR_border">
                  Joint design<br />Notes
                </th>
                <td style={{ width: "13%" }} className="PQR_noleft">
                  <span className="PQRforfont" style={{ float: "left",paddingLeft:"2px" }}>{getPQRValue(pdfData?.PQR_JD_JointDesign)}</span><br />
                  <span className="PQRforfont" style={{ float: "left",paddingLeft:"2px" }}>{getPQRValue(pdfData?.PQR_JD_Notes)}</span><br />
                </td>
                <td style={{ width: "17%", height: "90px" }} className="PQR_noleft">
                  {previewUrl1 && (
                    <img className="imgsizebig" style={{ marginTop: "5px", marginBottom: "10px", marginLeft: "3px", marginRight: "3px", width: "90%", height: "65px" }} src={previewUrl1} alt="Joint" />
                  )}
                </td>
                <td style={{ width: "17%", height: "90px" }} className="PQR_noleft">
                  {previewUrl2 && (
                    <img className="imgsizebig" style={{ marginTop: "5px", marginBottom: "10px", marginLeft: "3px", marginRight: "3px", width: "90%", height: "65px" }} src={previewUrl2} alt="Joint" />
                  )}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </>
    );
  }

  return (
    <>
      <div style={pqrStyles.group}>
        <div className="PQRbasemetal">JOINTS(QW- 402)</div>
      </div>
      <div style={pqrStyles.container}>
        <table id="table" className="PQRTable2">
          <tbody>
            <tr>
              <th style={{ width: "9.2%", paddingLeft: "3px", height: "65px" }} className="PQR_border">
                Joint design<br />Backing<br />Retainers<br />
                Groove angle <div className="PQRrcorner"> deg </div><br />
                Root opening <div className="PQRrcorner"> mm </div><br />
                Root face <div className="PQRrcorner"> mm </div><br />
                Notes<br />
              </th>
              <td style={{ width: "16%", height: "65px" }} className="PQR_noleft">
                <span className="PQRforfont" style={{ float: "left" }}>{getPQRValue(pdfData?.PQR_JD_JointDesign)}</span><br />
                <span className="PQRforfont" style={{ float: "left" }}>{getPQRValue(pdfData?.PQR_JD_Backing)}</span><br />
                <span className="PQRforfont" style={{ float: "left" }}>{getPQRValue(pdfData?.PQR_JD_Retainers)}</span><br />
                <span className="PQRforfont" style={{ float: "left" }}>{getPQRValue(pdfData?.PQR_JD_GrooveAngle)}</span><br />
                <span className="PQRforfont" style={{ float: "left" }}>{getPQRValue(pdfData?.PQR_JD_RootOpening)}</span><br />
                <span className="PQRforfont" style={{ float: "left" }}>{getPQRValue(pdfData?.PQR_JD_RootFace)}</span><br />
                <span className="PQRforfont" style={{ float: "left" }}>{getPQRValue(pdfData?.PQR_JD_Notes)}</span><br />
              </td>
              <td style={{ width: "17%", height: "60px" }} className="PQR_noleft">
                {previewUrl1 && (
                  <img className="imgsizebig" style={{ marginTop: "5px", marginBottom: "10px", marginLeft: "3px", marginRight: "3px", width: "90%", height: "65px" }} src={previewUrl1} alt="Joint" />
                )}
              </td>
              <td style={{ width: "17%", height: "60px" }} className="PQR_noleft">
                {previewUrl2 && (
                  <img className="imgsizebig" style={{ marginTop: "5px", marginBottom: "10px", marginLeft: "3px", marginRight: "3px", width: "90%", height: "65px" }} src={previewUrl2} alt="Joint" />
                )}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </>
  );
};

export default PQRJointTable;